var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 21.8281 20.8594 33.9844 16.8516 39C15.8906 40.1953 14.1094 40.1953 13.1484 39C9.14062 33.9844 0 21.8281 0 15C0 6.71875 6.71875 0 15 0C23.2812 0 30 6.71875 30 15Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 15.75V17.5156H6.36719L6.25781 16.1484L11 8.625H12.7891L10.8516 11.8672L8.49219 15.75H14.5625ZM13.2734 8.625V20H11.0234V8.625H13.2734ZM23.5078 8.625V9.83594L19.1094 20H16.7344L21.1328 10.3828H15.4688V8.625H23.5078Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin47);
export default __webpack_public_path__ + "static/media/Pin47.c84321ad599f86cc0400576fdc707881.svg";
export { ForwardRef as ReactComponent };